import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';

const CostOptimizationGrid = ({ services, smallVersion }) => {
  // Convert services object to an array of rows for the table
  const rows = services ? Object.keys(services).map((key) => ({
    serviceType: key,
    potentialCostSaving: services[key].potentialCostSaving,
  })) : [];

  return (
    <TableContainer
      component={Paper}
      style={{
        height: smallVersion ? '120px' : '100%', // Fit in small card height
        maxHeight: smallVersion ? '100px' : '100%', // Ensure scrolling within small version
        overflowY: 'scroll', // Enable vertical scrolling
      }}
    >
      <Table size={smallVersion ? 'small' : 'medium'}>
        <TableHead>
          <TableRow>
            <TableCell
              align="center"
              style={{
                fontSize: smallVersion ? '12px' : '16px', // Smaller font size
                fontWeight: 'bold', // Bold header text
                padding: '8px', // Reduced padding
                textAlign: 'left', // Center align text
                color: 'black',
              }}
            >
              Service Type
            </TableCell>
            <TableCell
              align="center"
              style={{
                fontSize: smallVersion ? '12px' : '16px', // Smaller font size
                fontWeight: 'bold', // Bold header text
                padding: '8px', // Reduced padding
                textAlign: 'left', // Center align text
                color: 'black',
              }}
            >
              Potential Cost Saving ($)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length > 0 ? (
            rows.map((row) => (
              <TableRow key={row.serviceType} style={{ height: smallVersion ? '24px' : '32px' }}>
                <TableCell
                  component="th"
                  scope="row"
                  style={{
                    fontSize: smallVersion ? '11px' : '14px', // Smaller font size
                    padding: '8px', // Margin inside cell
                    textAlign: 'left', // Center align text
                  }}
                >
                  {row.serviceType}
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    fontSize: smallVersion ? '11px' : '14px', // Smaller font size
                    padding: '8px', // Margin inside cell
                    textAlign: 'left', // Center align text
                    
                  }}
                >
                  {row.potentialCostSaving.toFixed(2)}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={2} align="center" style={{ fontSize: smallVersion ? '12px' : '14px' }}>
                <Typography variant="body2">No data available</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CostOptimizationGrid;
